import React, { useState } from 'react';
import './CorporatePageElementsCss/CorporateCollection.css'
import {
  Box,
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  InputLabel,
  Paper,
  Typography,
  Grid,
  Container,
  Chip
} from '@mui/material';

export default function CorporateCollection() {
  const [formData, setFormData] = useState({
    mobileNo: '',
    firstName: '',
    lastName: '',
    email: '',
    altMobile: '',
    dob: '',
    gender: 'male',
    address: '',
    state: 'West Bengal',
    city: '',
    landmark: '',
    pincode: '',
    referralDoctor: '',
    appointmentDate: '',
    appointmentTime: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    console.log('Form Data:', formData);
    alert('Form submitted successfully!');
  };

  const handleReset = () => {
    setFormData({
      mobileNo: '',
      firstName: '',
      lastName: '',
      email: '',
      altMobile: '',
      dob: '',
      gender: 'male',
      address: '',
      state: 'West Bengal',
      city: '',
      landmark: '',
      pincode: '',
      referralDoctor: '',
      appointmentDate: '',
      appointmentTime: '',
    });
  };

  return (
    <Box sx={{ 
      minHeight: '70vh', 
      // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      py: 4,
      position: 'relative'
    }}>
      <Container maxWidth="lg">
        <Paper elevation={6} sx={{ borderRadius: 3, overflow: 'hidden' }}>
          {/* Header */}
          <Box sx={{ 
            textAlign: 'center', 
            py: 3, 
            bgcolor: 'white'
          }}>
            <Typography variant="h4" sx={{ color: '#2c3e50', fontWeight: 600 }}>
              Home Collection
            </Typography>
          </Box>

          {/* Form Content */}
          <Box sx={{ p: 4 }}>
            <Grid container spacing={3}>
              {/* Mobile Number */}
              <Grid size = {{xs:12,md:12}}>
                <TextField
                  fullWidth
                  label="Mobile No"
                  name="mobileNo"
                  value={formData.mobileNo}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  size="small"
                  InputLabelProps={{ required: true }}
                  className='mobileNumber'
                />
              </Grid>

              {/* First Name & Last Name */}
              <Grid size = {{xs:12,md:4}}>
                <TextField
                  fullWidth
                  label="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  size="small"
                  variant="outlined"
                />
              </Grid>
              <Grid size = {{xs:12,md:4}}>
                <TextField
                  fullWidth
                  label="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  size="small"
                  variant="outlined"
                />
              </Grid>
              <Grid size = {{xs:12,md:4}}>
                <TextField
                  fullWidth
                  label="D.O.B"
                  name="dob"
                  type="date"
                  value={formData.dob}
                  onChange={handleChange}
                  required
                  size="small"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Email & Alt Mobile  gender */}
              <Grid size = {{xs:12,md:4}}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid size = {{xs:12,md:4}}>
                <TextField
                  fullWidth
                  label="Alt Mobile No."
                  name="altMobile"
                  value={formData.altMobile}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Gender */}
              <Grid size = {{xs:12,md:4}}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Gender</FormLabel>
                  <RadioGroup
                    row
                    name="gender"
                    size="small" 
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <FormControlLabel 
                      value="male" 
                      control={<Radio sx={{ color: '#4caf50', '&.Mui-checked': { color: '#4caf50' } }} />} 
                      label="Male" 
                    />
                    <FormControlLabel 
                      value="female" 
                      control={<Radio sx={{ color: '#4caf50', '&.Mui-checked': { color: '#4caf50' } }} />} 
                      label="Female" 
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {/* Address & Set Location &  city  */}
              <Grid size = {{xs:12,md:6}}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  size="small" 
                  required
                  multiline
                
                  variant="outlined"
                />
              </Grid>
             <Grid size = {{xs:12,md:3}} sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Button
                  fullWidth
                  variant="contained"
                  size="small" 
                  sx={{ 
                    bgcolor: '#4caf50', 
                    color: 'white',
                    borderRadius:'20px',
                    '&:hover': { bgcolor: '#45a049' }
                  }}
                  startIcon={<span>📍</span>}
                >
                  Set Location on Map
                </Button>
              </Grid>

               <Grid size = {{xs:12,md:3}}>
                <FormControl fullWidth>
                  <InputLabel>City Name</InputLabel>
                  <Select
                    name="city"
                    value={formData.city}
                    size="small" 
                    onChange={handleChange}
                    label="City Name"
                  >
                    <MenuItem value="">Select City</MenuItem>
                    <MenuItem value="Kolkata">Kolkata</MenuItem>
                    <MenuItem value="Mumbai">Mumbai</MenuItem>
                    <MenuItem value="Bangalore">Bangalore</MenuItem>
                    <MenuItem value="Chennai">Chennai</MenuItem>
                  </Select>
                </FormControl>
              </Grid>



              {/* State  */}
              <Grid size = {{xs:12,md:4}}>
                <FormControl fullWidth>
                  <InputLabel>State</InputLabel>
                  <Select
                    name="state"
                    value={formData.state}
                    size="small" 
                    onChange={handleChange}
                    label="State"
                  >
                    <MenuItem value="West Bengal">West Bengal</MenuItem>
                    <MenuItem value="Maharashtra">Maharashtra</MenuItem>
                    <MenuItem value="Karnataka">Karnataka</MenuItem>
                    <MenuItem value="Tamil Nadu">Tamil Nadu</MenuItem>
                    <MenuItem value="Delhi">Delhi</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
             

              {/* Landmark & Pincode */}
              <Grid size = {{xs:12,md:4}}>
                <TextField
                  fullWidth
                  label="Landmark"
                  name="landmark"
                  size="small" 
                  value={formData.landmark}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid size = {{xs:12,md:4}}>
                <TextField
                  fullWidth
                  label="Pincode"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  size="small" 
                  required
                  variant="outlined"
                />
              </Grid>

              {/* Referral Doctor & Appointment Time & date  */}
              <Grid size = {{xs:12,md:4}}>
                <FormControl fullWidth>
                  <InputLabel>Choose referral doctor</InputLabel>
                  <Select
                    name="referralDoctor"
                    value={formData.referralDoctor}
                    onChange={handleChange}
                    label="Choose referral doctor"
                    size="small" 
                  >
                    <MenuItem value="">Select Doctor</MenuItem>
                    <MenuItem value="dr1">Dr. Smith</MenuItem>
                    <MenuItem value="dr2">Dr. Johnson</MenuItem>
                    <MenuItem value="dr3">Dr. Patel</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size = {{xs:12,md:4}}>
                <FormControl fullWidth required>
                  <InputLabel>Appointment Time</InputLabel>
                  <Select
                    name="appointmentTime"
                    value={formData.appointmentTime}
                    onChange={handleChange}
                    size="small" 
                    label="Appointment Time"
                  >
                    <MenuItem value="">Select Time</MenuItem>
                    <MenuItem value="morning">Morning (9 AM - 12 PM)</MenuItem>
                    <MenuItem value="afternoon">Afternoon (12 PM - 3 PM)</MenuItem>
                    <MenuItem value="evening">Evening (3 PM - 6 PM)</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Appointment Date  */}
              <Grid size = {{xs:12,md:4}}>
                <TextField
                  fullWidth
                  label="Appointment Date"
                  name="appointmentDate"
                  size="small" 
                  type="date"
                  value={formData.appointmentDate}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: new Date().toISOString().split('T')[0] }}
                />
                {/*  Test Link  */}
              </Grid>
              <Grid size = {{xs:12,md:4}} sx={{ display: 'flex', alignItems: 'center' }}>
                <Button 
                  sx={{ color: '#4caf50', textTransform: 'none' }}
                  onClick={() => alert('Add/Update Test clicked')}
                  size="small" 
                >
                  Click to Add/Update Test
                </Button>
              </Grid>

              {/* Action Buttons &   Upload prescription &  Reset */}
              <Grid size = {{xs:12,md:3}}>
                <Button
                  fullWidth
                  className='Upload-button'
                  variant="contained"
                  size="small" 
                  sx={{ 
                  
                    color: 'white',
                    py: 1.5,
                    '&:hover': { bgcolor: '#45a049' }
                  }}
                  startIcon={<span>📄</span>}
                >
                  Upload prescription
                </Button>
              </Grid>
              <Grid size = {{xs:12,md:3}}>
                <Button
                  fullWidth
                  className='reset-button'
                  variant="contained"
                  onClick={handleReset}
                  size="small" 
                  sx={{ 
                    bgcolor: '#95a5a6',
                    color: 'white',
                    py: 1.5,
                    '&:hover': { bgcolor: '#7f8c8d' }
                  }}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>

            {/* Note Section */}
            <Box sx={{ 
              mt: 4, 
              mb: 3,
              bgcolor: '#d5f4e6',
              p: 2.5,
              borderRadius: 2,
              border: '1px solid #a8e6cf'
            }}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: '#2c3e50' }}>
                Note
              </Typography>
              <Typography variant="body2" sx={{ color: '#2c3e50' }}>
                <strong>Home collection charge is free on billing of above Rs. 500. (Except covid test)</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: '#2c3e50', mt: 0.5 }}>
                I allow RS Diagnostic to Call / Whatsapp / Mail / SMS
              </Typography>
            </Box>

            {/* Proceed Button */}
            <Box sx={{ textAlign: 'center' }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                
                size="small" 
                sx={{ 
                  bgcolor: '#4caf50',
                  color: 'white',
                  px: 8,
                  py: 2,
                  fontSize: '1rem',
                  fontWeight: 600,
                  '&:hover': { bgcolor: '#45a049' }
                }}
              >
                Proceed
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
      {/* Online Indicator */}
      <Chip 
        label="Online" 
        sx={{ 
          position: 'fixed',
          bottom: 20,
          right: 20,
          bgcolor: '#4caf50',
          color: 'white',
          fontWeight: 600,
          px: 2,
          py: 2.5,
          fontSize: '0.9rem',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
        }}
      />
    </Box>
  );
}